import React from 'react';
import { withPrefix } from 'gatsby';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { Container, Grid, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import LangageSelector from './LangageSelector';
import Link from './Link';

import { logoPath } from '../config';

const useStyles = makeStyles(theme => ({
  defaultStyle: {
    padding: theme.spacing(1),
  },
  logo: {
    maxHeight: theme.spacing(8),
  },
}));

const Header = ({ className, isHome = false, ...props }) => {
  const [t] = useTranslation();
  const classes = useStyles();

  return (
    <Box className={clsx(className, classes.defaultStyle)} {...props}>
      <Container>
        <Grid container item xs direction="row" justifyContent="space-between" alignItems="center">
          <Grid item>
            <LangageSelector />
          </Grid>
          {!isHome && (
            <Grid item>
              <Link to="/">
                {t('retour_accueil')}
              </Link>
            </Grid>
          )}
          <Grid item>
            <img src={withPrefix(logoPath)} alt="Logo" className={classes.logo} />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Header;
